module.exports = __webpack_public_path__ + "static/img/a7070xgri_pop4.1430685.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/images/a7070xgri_pop4.jpg
// module id = VVla
// module chunks = 0